import './PolicyStyles.css';
import { exportToWord } from '../utils/exportToWord';

const WorkplaceBullyingHarassmentPolicy = ({
  clientName,
  companyNumber,
  clientAddress,
  effectiveDate,
  hrContact,
  wellbeingOfficerContact,
}) => {
  const handleExportToWord = () => {
    const policyContent = document.getElementById('policy-content');
    exportToWord(policyContent.innerHTML, "Workplace_Bullying_and_Harassment_Policy.docx");
  };

  return (
    <div className="policy-container" id="policy-content">
      <h3 className="policy-title">Workplace Bullying and Harassment Policy</h3>

      <p className="policy-details"><strong>Company Name:</strong> {clientName || "[Insert Company Name]"}</p>
      <p className="policy-details"><strong>Company Number:</strong> {companyNumber || "[Insert Company Number]"}</p>
      <p className="policy-details"><strong>Company Address:</strong> {clientAddress || "[Insert Company Address]"}</p>
      <p className="policy-details"><strong>Policy Effective Date:</strong> {effectiveDate || "[Insert Effective Date]"}</p>

      <h4 className="section-title">1. Policy Statement</h4>
      <p className="section-content">
        {clientName || "The Company"} is committed to providing a workplace free from bullying, harassment, victimisation, and any form of discriminatory behaviour. We promote dignity, respect, and fairness for all employees, contractors, and visitors.
      </p>

      <h4 className="section-title">2. Definitions</h4>
      <p className="section-content"><strong>Bullying:</strong> Offensive, intimidating, malicious or insulting behaviour or an abuse or misuse of power which undermines, humiliates or injures the recipient.</p>
      <p className="section-content"><strong>Harassment:</strong> Unwanted conduct related to a protected characteristic (e.g., age, race, sex, disability) that violates a person's dignity or creates an intimidating, hostile, degrading, humiliating, or offensive environment.</p>

      <h4 className="section-title">3. Examples of Bullying and Harassment</h4>
      <ul>
        <li>Verbal abuse, threats, or insults.</li>
        <li>Exclusion or isolation from work activities.</li>
        <li>Unfair criticism or persistent undermining of work performance.</li>
        <li>Spreading malicious rumours or gossip.</li>
        <li>Unwanted physical contact or gestures.</li>
        <li>Discriminatory behaviour related to any protected characteristic.</li>
      </ul>

      <h4 className="section-title">4. Reporting Procedures</h4>
      <p className="section-content">
        Employees who believe they have been subjected to bullying or harassment should report the matter promptly to their line manager, HR department, or the Wellbeing Officer. Reports will be treated seriously, confidentially, and with sensitivity.
      </p>

      <h4 className="section-title">5. Investigation Process</h4>
      <p className="section-content">
        All reports will be thoroughly and impartially investigated. Both the complainant and the alleged perpetrator will be given an opportunity to present their case. The company will ensure protection against retaliation for those who raise concerns in good faith.
      </p>

      <h4 className="section-title">6. Support and Remedies</h4>
      <p className="section-content">
        Support will be provided to victims including counselling, mediation, or adjustments to working arrangements. Appropriate disciplinary action will be taken against perpetrators if allegations are substantiated.
      </p>

      <h4 className="section-title">7. Responsibilities</h4>
      <p><strong>Managers and Supervisors:</strong> Foster a respectful work environment, promptly address complaints, and enforce this policy.</p>
      <p><strong>Employees:</strong> Treat colleagues with respect and report concerns.</p>
      <p><strong>HR Department:</strong> Provide guidance, manage investigations, and maintain confidentiality.</p>
      <p><strong>Wellbeing Officer:</strong> Offer support and resources to affected individuals. Contact: {wellbeingOfficerContact || "[Insert Contact]"}</p>

      <h4 className="section-title">8. Training and Awareness</h4>
      <p className="section-content">
        Regular training sessions will be provided to all employees to promote awareness of bullying and harassment and to encourage a positive, inclusive workplace culture.
      </p>

      <h4 className="section-title">Employee Acknowledgment and Signature</h4>
      <p>I confirm that I have read, understood, and agree to comply with the Workplace Bullying and Harassment Policy.</p>
      <p>Employee Name: _________________________</p>
      <p>Employee Signature: _________________________</p>
      <p>Date: _________________________</p>

      <h4 className="section-title">Management Approval and Signature</h4>
      <p>This policy has been approved by senior management and is now in effect.</p>
      <p>Manager/Officer Name: _________________________</p>
      <p>Title: _________________________</p>
      <p>Signature: _________________________</p>
      <p>Date: _________________________</p>

      <div className="mt-4 text-center">
        <button
          onClick={handleExportToWord}
          className="bg-green-600 text-white px-6 py-2 rounded hover:bg-green-700 transition"
        >
          Export to Word
        </button>
      </div>
    </div>
  );
};

export default WorkplaceBullyingHarassmentPolicy;
